<template src="../templates/normal_fcont_196.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadColorioNenga from '../components/AppDownloadColorioNenga'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '196',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage,Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadColorioNenga
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['196-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['196-3']}
    ]};

  }
};
</script>
<style scoped>
/* TODO: アプルーバル用のCSS */
.date {
  font-size: 12px;
  color: #8d8d8d; 
  text-align: right; 
  width: 100%; 
  max-width: 720px; 
  margin-left: auto; 
  margin-right: auto;
}
</style>

